import React, { FC } from 'react';
import { TaskId } from 'api/models';
import { useTaskDetailQuery } from 'queries/task';

interface Props {
  taskId: number;
  projectId: number;
}

export const TaskName: FC<Props> = ({ projectId, taskId }) => {
  const { data } = useTaskDetailQuery(TaskId(projectId, taskId));

  if (data?.taskName) {
    return (
      <>
        {' '}
        {data.taskName.length > 120
          ? `${data.taskName.slice(0, 120)}...`
          : data.taskName}{' '}
      </>
    );
  }

  return <></>;
};
